import React, { useState } from 'react'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { Label, ModalBody } from 'reactstrap'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { DropDownList } from '@/components/dropDownList'
import Resx from '@/components/Resx'
import context from '@/context'

const AddDataCrossingAllowedCombinationDialog = React.memo(function AddDataCrossingAllowedCombinationDialog (props) {
  const { onAction, item } = props
  const { id, firstRelatedPersonType, secondRelatedPersonType } = item || {}
  const [firstJob, setFirstJob] = useState(firstRelatedPersonType || null)
  const [secondJob, setSecondJob] = useState(secondRelatedPersonType || null)
  const onConfirm = () => { onAction({ id: id, firstRelatedPersonTypeId: firstJob.id, secondRelatedPersonTypeId: secondJob.id }) }

  return (
    <ValidationBoundary>
      <BasicHeader title='' {...props} />
      <ModalBody>
        <Label><Resx name='DataCrossings.FirstRelation' /></Label>
        <Validator name='firstJob' value={firstJob} required>
          <DropDownList
            dataSource={context.cache.getRelatedPersonTypes}
            isCodeList
            clientSide
            value={firstJob}
            onChange={({ item }) => setFirstJob(item)}
          />
        </Validator>
        <Label><Resx name='DataCrossings.SecondRelation' /></Label>
        <Validator name='secondJob' value={secondJob} required>
          <DropDownList
            dataSource={context.cache.getRelatedPersonTypes}
            isCodeList
            clientSide
            value={secondJob}
            onChange={({ item }) => setSecondJob(item)} />
        </Validator>
      </ModalBody>

      <ValidationState render={({ isValid }) =>
        <ConfirmFooter {...props} onAction={onConfirm} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
})

export default {
  component: AddDataCrossingAllowedCombinationDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/addDataCrossingAllowedCombination.js